/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputOtgShort } from './OutputOtgShort';
import {
    OutputOtgShortFromJSON,
    OutputOtgShortFromJSONTyped,
    OutputOtgShortToJSON,
} from './OutputOtgShort';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminUser
 */
export interface OutputAdminUser {
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputAdminUser
     */
    blockReasons?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    brigadeId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    brigadeName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    deltaLogin?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    division: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    divisionName: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    lastActivity?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    osg?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    osgName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    otg?: number;
    /**
     * 
     * @type {Array<OutputOtgShort>}
     * @memberof OutputAdminUser
     */
    otgs?: Array<OutputOtgShort>;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    role: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminUser
     */
    twoFactorEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUser
     */
    zone?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUser
     */
    zoneName: string;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputAdminUser
     */
    zones?: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputAdminUser interface.
 */
export function instanceOfOutputAdminUser(value: object): boolean {
    if (!('division' in value)) return false;
    if (!('divisionName' in value)) return false;
    if (!('email' in value)) return false;
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('role' in value)) return false;
    if (!('zoneName' in value)) return false;
    return true;
}

export function OutputAdminUserFromJSON(json: any): OutputAdminUser {
    return OutputAdminUserFromJSONTyped(json, false);
}

export function OutputAdminUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminUser {
    if (json == null) {
        return json;
    }
    return {
        
        'blockReasons': json['blockReasons'] == null ? undefined : json['blockReasons'],
        'brigadeId': json['brigadeId'] == null ? undefined : json['brigadeId'],
        'brigadeName': json['brigadeName'] == null ? undefined : json['brigadeName'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'deltaLogin': json['deltaLogin'] == null ? undefined : json['deltaLogin'],
        'division': json['division'],
        'divisionName': json['divisionName'],
        'email': json['email'],
        'id': json['id'],
        'lastActivity': json['lastActivity'] == null ? undefined : json['lastActivity'],
        'name': json['name'],
        'osg': json['osg'] == null ? undefined : json['osg'],
        'osgName': json['osgName'] == null ? undefined : json['osgName'],
        'otg': json['otg'] == null ? undefined : json['otg'],
        'otgs': json['otgs'] == null ? undefined : ((json['otgs'] as Array<any>).map(OutputOtgShortFromJSON)),
        'role': json['role'],
        'twoFactorEnabled': json['twoFactorEnabled'] == null ? undefined : json['twoFactorEnabled'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'zoneName': json['zoneName'],
        'zones': json['zones'] == null ? undefined : ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputAdminUserToJSON(value?: OutputAdminUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blockReasons': value['blockReasons'],
        'brigadeId': value['brigadeId'],
        'brigadeName': value['brigadeName'],
        'comment': value['comment'],
        'deltaLogin': value['deltaLogin'],
        'division': value['division'],
        'divisionName': value['divisionName'],
        'email': value['email'],
        'id': value['id'],
        'lastActivity': value['lastActivity'],
        'name': value['name'],
        'osg': value['osg'],
        'osgName': value['osgName'],
        'otg': value['otg'],
        'otgs': value['otgs'] == null ? undefined : ((value['otgs'] as Array<any>).map(OutputOtgShortToJSON)),
        'role': value['role'],
        'twoFactorEnabled': value['twoFactorEnabled'],
        'zone': value['zone'],
        'zoneName': value['zoneName'],
        'zones': value['zones'] == null ? undefined : ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

